//
// from node_modules
import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

//
// CSS import
import styles from './Home.css'

//
// Images
import homeBackground from './home_bg.svg';

const home = (props) => {
    let homeBackgroundStyles = {
        background: 'url(' + homeBackground + ') center center / cover no-repeat'
    };

    const homeContentClasses = props.showSidebar ? [styles.HomeContent, styles.showSidebar] : [styles.HomeContent];
    const homeLinks = process.env.REACT_APP_HOME_LINKS.map((linkObj, index) => {
        let link =  null;

        if (linkObj.isExternal) {
            link = (
                <a href={linkObj.url} target="_blank" title={linkObj.title} rel="noopener noreferrer">
                    <i><FontAwesomeIcon icon={linkObj.icon} /></i>
                    <span>{linkObj.text}</span>
                </a>
            );
        }
        else {
            link = (
                <Link to={linkObj.url} title={linkObj.title}>
                    <i><FontAwesomeIcon icon={linkObj.icon} /></i>
                    <span>{linkObj.text}</span>
                </Link>
            );
        }

        return (<li key={index}>{link}</li>)
    });

    return (
        <div className={styles.Home} style={homeBackgroundStyles}>
            <div className={homeContentClasses.join(' ')}>
                <h1>{process.env.REACT_APP_APP_NAME}</h1>
                <div className={styles.Description} dangerouslySetInnerHTML={{__html: process.env.REACT_APP_HOME_DESC}}></div>
                <ul className={styles.Links}>
                    {homeLinks}
                </ul>
            </div>
        </div>
    )
};

export default home;


// WEBPACK FOOTER //
// ./src/components/Home/Home.js